import styled from "styled-components";
import { CheckedIcon, ClearIcon } from "../Svg";

export const TextEditor = styled.div`
  position: relative;
`;

export const Text = styled.p`
  color: #1a0dab;
  font-size: 18px;
  text-align: left;
  padding: 2px 6px;
  cursor: pointer;

  :hover {
    background-color: #f2f2f2;
    border-radius: 4px;
  }
`;

export const Editor = styled.div`
  padding: 10px;
  text-align: left;
  position: relative;
`;

export const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Label = styled.label`
  color: black;
  display: block;

  font-family: Rubik;
  font-size: 13px;
  font-weight: 600;

  line-height: 1.6;
  text-align: left;
  text-transform: capitalize;
`;

export const MaxLength = styled.span`
  display: block;
  font-family: Rubik;
  font-size: 13px;
  font-weight: 400;
`;

export const Input = styled.input`
  width: 100%;
  height: 40px;
  padding: 0 74px 0 6px;

  border: 1px solid #1e22ff;
  border-radius: 6px;
  background-color: #f9f8fb;

  font-family: Rubik;
  font-size: 14px;
  font-weight: 400;

  letter-spacing: 0px;
  line-height: 28px;
  text-align: left;
  color: #302f38;
  transition: all 2s;

  &:focus,
  &:active {
    border: 1px solid #1e22ff;
  }
`;

export const Actions = styled.div`
  display: flex;
  position: absolute;
  bottom: 15px;
  right: 15px;

  button:first-child {
    margin-right: 4px;
  }
`;

export const IconChecked = styled(CheckedIcon)`
  display: flex;
  width: 20px;
  height: 20px;
`;

export const IconClear = styled(ClearIcon)`
  display: flex;
  width: 20px;
  height: 20px;
`;
